import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  Pagination,
  Stack,
  TablePagination,
  TableSortLabel,
} from "@mui/material";

interface Props {
  tableHeadings: { [key: string]: string };
  rows: any[];
}

const WithoutFtdAndNetRevTable = ({ tableHeadings, rows }: Props) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const headCells = Object.entries(tableHeadings);

  const handleChangePage = (_: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      <TableContainer className="">
        <Table
          size="small"
          stickyHeader
          sx={{ minWidth: "1800px", whiteSpace: "nowrap" }}
        >
          <TableHead>
            <TableRow>
              {headCells.map(([_, value], index) => (
                <TableCell key={index} align="left">
                  <TableSortLabel>
                    {value && typeof value === "string" ? value : ""}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <React.Fragment key={row.cron_id}>
                  <TableRow
                    sx={{
                      "& > *": {
                        borderBottom:
                          "1px solid rgba(224, 224, 224, 1) !important",
                      },
                    }}
                  >
                    {headCells.map(([key], cellIndex) => (
                      <TableCell key={cellIndex} align="left">
                        {key === "brand_name" ? (
                          <> {row[key] ? row[key] : "N/A"}</>
                        ) : key === "brand_id" ? (
                          <> {row[key] ? row[key] : "N/A"}</>
                        ) : key === "brand_action_date" ? (
                          <> {row[key] ? row[key] : "N/A"}</>
                        ) : key === "click_out" ? (
                          <> {row[key] ? row[key] : "N/A"}</>
                        ) : row[key] ? (
                          row[key]
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack
        spacing={1}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          classes={{
            displayedRows: "hidden-displayed-rows", // Apply the custom class
          }}
          sx={{
            ".MuiTablePagination-actions": {
              display: "none",
            },
            ".MuiTablePagination-input": {
              marginLeft: "15px",
            },
          }}
        />
        <Pagination
          count={Math.ceil(rows?.length / rowsPerPage)}
          page={page + 1}
          showFirstButton
          showLastButton
          className="pagination-button"
          color="secondary"
          size="small"
          sx={{
            ".css-wjh20t-MuiPagination-ul": {
              justifyContent: "center",
            },
          }}
          onChange={(_, value) => handleChangePage(null, value - 1)}
        />
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={rows?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            ".css-16c50h-MuiInputBase-root-MuiTablePagination-select,.MuiTablePagination-selectLabel":
              {
                display: "none",
              },
            ".MuiTablePagination-actions": {
              display: "none",
            },
            ".MuiTablePagination-toolbar": {
              paddingRight: "16px",
            },
          }}
        />
      </Stack>
    </>
  );
};

export default WithoutFtdAndNetRevTable;
